import { Link, Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural } from '@change-corgi/core-react/i18n';

import { useTagline } from './hooks';

export const Tagline: React.FC = () => {
	const {
		data: { totalUserCount, totalUserCountLocalized, learnMoreLinkHref },
		actions: { onLearnMoreClick },
	} = useTagline();

	return (
		<div className="mx-auto flex flex-col items-center gap-11 px-3 text-center lg:px-0">
			<Link href={learnMoreLinkHref} onClick={onLearnMoreClick} data-qa="learn-more-link">
				<Translate value="corgi.homepage.hero_section.learn_more_link" />
			</Link>
			<Text as="p" variant="heading" size="small" data-testid="homepage-hero-tagline">
				<TranslatePlural
					value="corgi.homepage.hero_section.description"
					count={totalUserCount}
					replacements={{ totalUserCount: totalUserCountLocalized }}
				/>
			</Text>
		</div>
	);
};
